import apiClient from '../apiClient';
import { DELETE_IMAGE_TRANSPORTATION_UNIT_URL } from '../apiUrl';

const deleteImageTransportationUnitApi = Id => {
  return apiClient.delete(DELETE_IMAGE_TRANSPORTATION_UNIT_URL(Id));
};

export default deleteImageTransportationUnitApi;
